import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

import Header from "./Header/Header.jsx";
import Loader from "./Loader/Loader.jsx";
import Footer from "./Footer/Footer.jsx";

const Home = lazy(() => import("../pages/Home/Home.jsx"));
const Portfolio = lazy(
  () => import("../pages/PortfolioPage/PortfolioPage.jsx"),
);
const ProjectPage = lazy(() => import("../pages/ProjectPage/ProjectPage.jsx"));
const Blog = lazy(() => import("../pages/Blog/Blog.jsx"));
const Contact = lazy(() => import("../pages/Contact/Contact.jsx"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound.jsx"));

export default function App() {
  return (
    <div className="main-container">
      <Header />

      <main className="content">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            {/* <Route path="/portfolio/:id" element={<ProjectPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} /> */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>

      <Footer />
    </div>
  );
}
